export enum Section {
  ALL = 'all',
  EDITIONS = 'editions',
  TOKENS = 'tokens'
}
